const POINT_GET_LIST_REQUEST = 'POINT_GET_LIST_REQUEST';
const POINT_GET_LIST_SUCCESS = 'POINT_GET_LIST_SUCCESS';
const POINT_GET_LIST_FAILURE = 'POINT_GET_LIST_FAILURE';

export default {
  POINT_GET_LIST_REQUEST,
  POINT_GET_LIST_FAILURE,
  POINT_GET_LIST_SUCCESS,
};
